import { getProviderFeatures, getProviderManagerFeatures } from "./base-features/provider-features";
import { getAdminFeatures } from "./base-features/admin-features";

export const ROLE_FEATURES = {

    EMPLOYEE: getAdminFeatures(),

    BUSINESS_ADMIN: getProviderFeatures(),

    PROVIDER_MANAGER: getProviderManagerFeatures(),

} as const;